export default __webpack_public_path__ + "static/media/alabi.3ce14194.png";